import { render } from "./ItemList.vue?vue&type=template&id=63ce3cdc"
import script from "./ItemList.vue?vue&type=script&lang=ts"
export * from "./ItemList.vue?vue&type=script&lang=ts"
script.render = render

export default script